import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, Crown } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    let timer;
    const poll = async () => {
      attempts.current += 1;
      const u = await refreshUser();
      if (u && u.is_premium) { setState("success"); return; }
      if (attempts.current >= 8) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [refreshUser]);

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center py-16 text-center" data-testid="payment-result">
      {state === "checking" && (<><Loader2 className="mb-4 h-14 w-14 animate-spin text-emerald-700" /><h1 className="font-serif text-3xl font-bold text-emerald-950">Confirming your subscription…</h1><p className="mt-2 text-slate-600">Please wait a moment.</p></>)}
      {state === "success" && (<>
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-500 text-white"><Crown className="h-8 w-8" /></div>
        <h1 className="font-serif text-3xl font-bold text-emerald-950">Welcome to Premium!</h1>
        <p className="mt-2 text-slate-600">Your subscription is active across all your devices.</p>
        <Button onClick={() => navigate("/matches")} data-testid="payment-continue-btn" className="mt-6 rounded-full bg-emerald-800 text-white hover:bg-emerald-900">See your matches</Button>
      </>)}
      {state === "timeout" && (<><CheckCircle2 className="mb-4 h-14 w-14 text-amber-500" /><h1 className="font-serif text-3xl font-bold text-emerald-950">Almost there</h1><p className="mt-2 text-slate-600">Your payment is processing. Premium will activate shortly — refresh in a minute.</p><Button onClick={() => navigate("/premium")} className="mt-6 rounded-full bg-emerald-800 text-white">Back to Premium</Button></>)}
    </div>
  );
}
